import { jsxs as x, jsx as d } from "react/jsx-runtime";
import { useCallback as i, useEffect as v, Fragment as b } from "react";
import E from "../Overlay/Overlay.js";
import h from "./components/ContentBox/ContentBox.js";
function L({
  children: s,
  partOfJourney: a = !1,
  inContainer: o = !1,
  onCloseClick: e,
  padding: f = "xxlarge",
  maxWidth: m = "medium",
  fullscreenOnMobile: c = !1,
  overflowY: u = "auto",
  noTopImageContainer: l = !1,
  allowOutsideClick: p
}) {
  const t = !o && document.body && document.body.style, n = i(
    (y) => {
      y.key === "Escape" && e && e();
    },
    [e]
  );
  v(() => (document.addEventListener("keydown", n), t && (document.body.style.overflow = "hidden"), () => {
    document.removeEventListener("keydown", n), t && (document.body.style.overflow = "auto");
  }), [t]);
  const r = /* @__PURE__ */ d(h, { ...{
    inContainer: o,
    onCloseClick: e,
    padding: f,
    maxWidth: m,
    fullscreenOnMobile: c,
    overflowY: u,
    noTopImageContainer: l,
    allowOutsideClick: p
  }, children: s });
  return a ? r : /* @__PURE__ */ x(b, { children: [
    /* @__PURE__ */ d(
      E,
      {
        onCloseClick: e,
        position: o ? "absolute" : "fixed"
      }
    ),
    r
  ] });
}
export {
  L as default
};
